import { environment } from './environment';

export const config = {
  api: {
    baseUrl: environment.apiUrl,
    endpoints: {
      improvePrompt: '/improve',
      health: '/',
    },
  },
  features: environment.features,
  app: {
    name: 'Promptasaurus',
    tagline: 'Make Your Prompts Roar!',
    version: '1.0.0',
    environment: environment.env,
  },
  extension: {
    chromeStoreUrl: '#', // Will be updated when published
    firefoxStoreUrl: '#', // Future support
  },
};

// Helper to build full API URLs (delegates to environment service)
export const getApiUrl = (endpoint: string): string => {
  return environment.apiEndpoint(endpoint);
};

// Re-export environment utilities for convenience
export { environment, getEnvironment, isDevelopment, isProduction, apiEndpoint } from './environment';
export type { Environment, EnvironmentConfig } from './environment';